import { useInfiniteQuery } from '@tanstack/react-query';
import { getForecastInspectPending } from 'Services/forecasts';
import { trackError } from 'Utils/errorMonitoring';
import { RESULTS_PER_PAGE } from 'Utils/constants';

export default function useInfiniteForecastInspectPending(id, filters, { includeReconciled = false } = {}) {
    const { data, isFetching, fetchNextPage, hasNextPage, isLoading, refetch } = useInfiniteQuery(
        ['forecast', id, 'inspect', 'pending', filters, includeReconciled],
        async ({ pageParam = 1 }) => {
            const response = await getForecastInspectPending(id, {
                ...filters,
                include_reconciled: includeReconciled,
                page: pageParam,
            });
            return response;
        },
        {
            refetchOnWindowFocus: false,
            onError: (err) => trackError(err),
            getNextPageParam: (lastPage, allPages) => {
                const pagesLoaded = allPages.length;
                const totalPages = Math.ceil(lastPage.count / RESULTS_PER_PAGE);
                return pagesLoaded < totalPages ? pagesLoaded + 1 : false;
            },
        },
    );

    const invoices =
        data?.pages?.reduce((acc, page) => {
            return [...acc, ...page.invoices];
        }, []) ?? [];

    const recurrences =
        data?.pages?.reduce((acc, page) => {
            return [...acc, ...page.recurrences];
        }, []) ?? [];

    return {
        invoices,
        recurrences,
        count: data?.pages?.[0]?.count ?? null,
        isLoading,
        hasNextPage,
        isFetching,
        fetchNextPage,
        refetch,
    };
}
